import * as S from './template.styles';

interface CreditCardTemplateProps {
  color: string;
}

const CreditCardTemplate = ({ color }: CreditCardTemplateProps) => {
  return (
    <S.Wrapper
      $bgColor={color}
      style={{ backgroundImage: `url(/passenger/images/static/card-template.svg)` }}
    ></S.Wrapper>
  );
};

export default CreditCardTemplate;
